var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-md-none"},[_c('SideWidgetMobile')],1),_c('div',{staticClass:"d-none d-md-flex"},[_c('SideWidget')],1),_c('CreerCompteHeader'),_c('CreerCompteForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }